module.exports = __webpack_public_path__ + "img/round2-iteration4.53bb2fa6.png";